// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__o5sM_","signUpBase":"styles_signUpBase__5oRjQ"};